const products = [
  {
    name: "Camiseta Golden Goat",
    description:
      "Camiseta negra con logo en la parte delantera e ilustración en la trasera",
    imageFront: "./images/camiseta-carnero-back.jpeg",
    imageBack: "./images/camiseta-carnero.jpeg",
    price: 15,
  },
  {
    name: "Camiseta The Endless Path",
    description: "Camiseta blanca con logo en la parte trasera e ilustración en la delantera",
    imageFront: "./images/camiseta-endless.jpg",
    imageBack: "./images/camiseta-endless-back.jpg",
    price: 15,
  },
  {
    name: "Tote Bag",
    description: "Tote Bag de algodón con diseño The Endless Path",
    imageFront: "./images/tote.jpg",
    imageBack: "",
    price: 10,
  },
];

export default products;
